import { SERVICE_MESSAGE } from '../constants/serviceMessage';
var SERVER_RESTART = 'SERVER_RESTART';
function restart(state, action) {
    if (state === void 0) { state = undefined; }
    if (action.type == SERVICE_MESSAGE) {
        if (action.message.type == SERVER_RESTART) {
            var now = Math.floor(new Date().getTime() / 1000);
            return {
                restart: {
                    notificationReceivedTimestamp: now,
                    notificationRestartETA: action.message.data.restartAfter,
                    scheduledTimestamp: action.message.data.restartAfter + now,
                    requiresUpdate: action.message.data.requiresUpdate
                }
            };
        }
    }
    if (state === undefined)
        return { restart: undefined };
    return state;
}
export default restart;



//////////////////
// WEBPACK FOOTER
// ./src/reducers/restart.ts
// module id = 727
// module chunks = 0